
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clockInRequest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClockInAdminRequestObjectInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveClockInAdminRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clockInAdminRequestObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clockInRequest"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"layoff"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maintenance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"driver"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lunchTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"van"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employee"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employmentStartDateStr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employmentEndDateStr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"driver"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"part"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyCode"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subpart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"milling"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"millingHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originalTimestampStr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clockInItems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"clockInVehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceDateStr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preparation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preparationHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transfer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minutesWorked"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":887}};
    doc.loc.source = {"body":"mutation (\n  $clockInRequest: ClockInAdminRequestObjectInput!\n) {\n  saveClockInAdminRequest (\n    clockInAdminRequestObject: $clockInRequest\n  ) {\n    id\n    allowance\n    layoff\n    maintenance\n    driver\n    lunchTime\n    vehicleCode\n    confirmed\n    van\n    employee {\n      id\n      name\n      employmentStartDateStr\n      employmentEndDateStr\n      driver\n    }\n    part {\n      id\n      keyCode\n      description\n    }\n    project {\n      id\n      keyCode\n      label\n      parts {\n        id\n        description\n        keyCode\n      }\n    }\n    subpart\n    milling\n    millingHours\n    originalTimestampStr\n    clockInItems {\n      hour\n      id\n      quantity\n      vehicleCode\n    },\n    clockInVehicles {\n      id\n      hours\n      vehicle {\n        id\n        code\n      }\n    }\n    referenceDateStr\n    preparation\n    preparationHours\n    transfer\n    minutesWorked\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
